exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/* width */\n::-webkit-scrollbar {\n  width: 4px;\n  height: 7px;\n}\n/* Track */\n::-webkit-scrollbar-track {\n  background: #ffffff;\n}\n/* Handle */\n::-webkit-scrollbar-thumb {\n  background: #1396EC;\n  border-radius: 5px;\n}\n/* Handle on hover */\n::-webkit-scrollbar-thumb:hover {\n  background: #1396EC;\n}\n", ""]);

// exports
